import type { ReactElement } from 'react';
import { PageHeader } from '@/shared/ui';
import { OrderInquiryList } from '@/widgets/order-inquiry-list';

/** 어드민 교환·환불 문의(/order-inquiries) — 목록 위젯을 조합만 한다. */
export const OrderInquiriesPage = (): ReactElement => (
  <>
    <PageHeader
      title="교환·환불 문의"
      description="고객이 받아 본 뒤 접수한 불량·오배송·수량 부족 문의입니다. 답변하면 고객에게 메일이 갑니다."
    />
    <OrderInquiryList />
  </>
);
